<template>
  <div>
    <mt-cell v-for="item in applyList" :title="item.user_name + ' ' + item.user_code" :label="item.apply_date" v-bind:key="item.id">
      <mt-button type="primary" plain size="small" @click.native="untie(item.id)">解除绑定</mt-button>
    </mt-cell>
  </div>
</template>

<script>
import MainService from '@/service/main'
export default {
  name: 'ApplyUntie',
  data () {
    return {
      applyList: []
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      this.$indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      MainService.getApply()
        .then(res => {
          if (res.data.result_code === 200) {
            this.applyList = res.data.data
          } else {
            this.$messagebox.alert({
              message: '获取数据失败！',
              title: '提示信息',
              showCancelButton: false
            })
          }
        })
        .catch(res => {
          console.log(res)
        })
        .finally(() => this.$indicator.close())
    },
    untie (id) {
      this.$indicator.open({
        text: '处理中...',
        spinnerType: 'fading-circle'
      })

      MainService.untieApply(id)
        .then(res => {
          if (res.data.result_code === 200) {
            this.$toast('处理成功')
            this.initData()
          }
        })
        .catch(res => {
          console.log(res)
        })
        .finally(() => this.$indicator.close())
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ApplyUntie.vue